module.exports = __webpack_public_path__ + "static/media/CC.8d316233.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CC.svg
// module id = 2125
// module chunks = 7